'use client';

import { TrackProperties } from '@/app/(main)/_components/logger/analytics/plugins/analytics-plugin.types';
import { AnalyticsEnumKeyType } from '@/types/enums/analytics/analytics.enum';
import { useTrackUserView } from '@/app/(main)/_components/logger/analytics/use-track-user-view.hook';

export interface TrackUserViewProps {
  eventName: AnalyticsEnumKeyType;
  properties?: TrackProperties;
}

export const TrackUserView = (props: TrackUserViewProps) => {
  useTrackUserView(props);

  return null;
};
